import { render } from "./person-role-attachment.vue?vue&type=template&id=3f495c88"
import script from "./person-role-attachment.vue?vue&type=script&lang=js"
export * from "./person-role-attachment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__